import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface UiState {
  branchId: string | null;
  dark: boolean;
  sidebarOpen: boolean;
  calendarView: 'day' | 'week';
  setBranch: (id: string) => void;
  toggleDark: () => void;
  setSidebar: (open: boolean) => void;
  setCalendarView: (v: 'day' | 'week') => void;
}

const safeStorage = createJSONStorage(() => {
  try {
    localStorage.setItem('__t', '1');
    localStorage.removeItem('__t');
    return localStorage;
  } catch {
    const mem = new Map<string, string>();
    return { getItem: (k) => mem.get(k) ?? null, setItem: (k, v) => void mem.set(k, v), removeItem: (k) => void mem.delete(k) };
  }
});

export const useUi = create<UiState>()(
  persist(
    (set) => ({
      branchId: null,
      dark: false,
      sidebarOpen: false,
      calendarView: 'day',
      setBranch: (branchId) => set({ branchId }),
      toggleDark: () => set((s) => ({ dark: !s.dark })),
      setSidebar: (sidebarOpen) => set({ sidebarOpen }),
      setCalendarView: (calendarView) => set({ calendarView }),
    }),
    { name: 'ss_ui', storage: safeStorage, partialize: (s) => ({ branchId: s.branchId, dark: s.dark, calendarView: s.calendarView }) },
  ),
);
